import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_3 = {
  class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_4 = { class: "svg-icon svg-icon-1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-175px py-4",
  "data-kt-menu": "true"
}
const _hoisted_7 = { class: "menu-item px-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/russia.svg",
    alt: "flag ru"
  })
], -1)
const _hoisted_9 = { class: "menu-item px-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg",
    alt: "flag en"
  })
], -1)
const _hoisted_11 = { class: "menu-item px-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/france.svg",
    alt: "flag fr"
  })
], -1)
const _hoisted_13 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_14 = {
  class: "btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_15 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("img", {
            class: "w-30px h-30px rounded-1",
            src: _ctx.currentLanguageLocale.flag,
            alt: "flag"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('ru'))),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('ru') }])
            }, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("ru")), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en'))),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }])
            }, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("en")), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('fr'))),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('fr') }])
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("fr")), 1)
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}